// import GetBrandFromManufacturer from "./GetBrandFromManufacturer";
import GetManufacturerFromBrand from "./GetManufacturerFromBrand";

export default function(route) {
    if (route.params && route.params.brand) {
        route.meta.brand = route.params.brand;
        route.meta.manufacturer = GetManufacturerFromBrand(route.params.brand);
    }
    return route.meta;
}